<template>
  <div>
        <span class="custom-chip" v-if="searched.id"><strong>Nr vouch.:</strong>&nbsp;{{searched.id}}
          <span class="close-icon" @click="changeSearchData('id')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.invoice_number"><strong>Nr FV:</strong>&nbsp;{{searched.invoice_number}}
          <span class="close-icon" @click="changeSearchData('invoice_number')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.type_id"><strong>Typ:</strong>&nbsp;{{convertTypeToName(searched.type_id)}}
          <span class="close-icon" @click="changeSearchData('type_id')"><v-icon size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.status"><strong>Status:</strong>&nbsp;{{searched.status | convertStatusToName}}
          <span class="close-icon" @click="changeSearchData('status')"><v-icon size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.created"><strong>Utworzono:</strong>&nbsp;{{searched.created}}
          <span class="close-icon" @click="changeSearchData('created')"><v-icon size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.expired"><strong>Wygasa:</strong>&nbsp;{{searched.expired}}
          <span class="close-icon" @click="changeSearchData('expired')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>
    <span class="custom-chip" v-if="searched.realized"><strong>Zrealizowano:</strong>&nbsp;{{searched.realized}}
          <span class="close-icon" @click="changeSearchData('realized')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>
    <span class="custom-chip" v-if="searched.employeeId"><strong>Pracownik:</strong>&nbsp;{{searched.employeeId.name}} {{searched.employeeId.surname}}
          <span class="close-icon" @click="changeSearchData('employeeId')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span style="display: inline-block; margin-bottom: 10px">
          <button class="btn-search-toggle"
                  @click="toggle = !toggle; $emit('toggleSearch', toggle)">
            <v-icon size="15px">fas fa-search</v-icon>
          </button>
          <v-btn color="#555474" class="mt-0 mb-0 mr-0 ml-2" @click="$router.push({name: 'CreateVoucher'})" dark>
            <v-icon size="15px" class="icon-btn">fas fa-plus</v-icon>&nbsp;Dodaj voucher
          </v-btn>
        </span>
  </div>
</template>

<script>
  export default {
    name: 'VoucherChips',
    props: {
      searched: Object,
      searchVouchers: Boolean,
    },
    data() {
      return {
        toggle: false,
      };
    },
    methods: {
      changeSearchData(element) {
        this.$emit('updateData', element);
      },
    },
    filters: {
      convertStatusToName(status) {
        switch (status) {
          case 'F':
            return 'Zakończone';
          case 'N':
            return 'Nowe';
          case 'I':
            return 'W realizacji';
          default:
            return 'Nieznany status';
        }
      },
    },
  };
</script>

<style scoped>

</style>
